<template>
  <section class="card">
    <div class="card-body">
      <h3 class="text-center py-3">
        {{ textData.quotationTitle }}
      </h3>
      <!-- Service area ac cleaning  -->
      <section class="mt-4" v-if="serviceId === 16">
        <label>{{ $t('message.terms_of_service') }}</label>
        <ul class="list-unstyled">
          <li>
            <span class="bullet-notification -status-pending">
              <i class="fas fa-circle"></i>
            </span>
            {{ $t('message.service_request.ac_cleaning_service_condition01') }}
          </li>
          <li>
            <span class="bullet-notification -status-pending">
              <i class="fas fa-circle"></i>
            </span>
            {{ $t('message.service_request.ac_cleaning_service_condition02') }}
          </li>
        </ul>
        <hr>
      </section>

      <!-- Service area big cleaning  -->
      <section class="mt-4" v-if="serviceId === 13 || serviceId == 24">
        <label>{{ $t('message.terms_of_service') }}</label>
        <ul class="list-unstyled">
          <li>
            <span class="bullet-notification -status-pending">
              <i class="fas fa-circle"></i>
            </span>
            {{ (serviceId === 13) ? $t('message.service_request.big_cleaning_service_condition01') : $t('message.service_request.disinfectant_cleaning_service_condition01') }}
          </li>
        </ul>
        <hr>
      </section>

      <!-- Contact information -->
      <label>
        {{ $t('message.service_request.contact_information') }}
        <span class="text-danger">*</span>
      </label>
      <section v-if="!isEditing">
        <div class="card shadow-sm">
          <div class="card-body">
            <ul class="list-unstyled">
              <li class="mb-2"><strong>{{ contactData.name }}</strong></li>
              <li class="mb-2">{{ contactData.email }}</li>
              <li class="mb-2">{{ contactData.tel }}</li>
            </ul>
            <div class="mt-2">
              <a href=""
                 class="text-primary-link"
                 @click.prevent="isEditing = true">
                {{ $t('message.booking.checkout_step.edit_data') }}
              </a>
            </div>
          </div>
        </div>
      </section>
      <section class="mt-2" v-else>
        <div class="form-group">
          <label for="name">
            {{ $t('message.big_cleaning.contact_name') }}
            <span class="text-danger">*</span>
          </label>
          <input type="text"
                 class="form-control input-jumbo"
                 name="name"
                 id="name"
                 v-model="contactData.name"
                 ref="name"
                 v-validate="'required'">
          <div class="mt-2 text-remark -status-alert" v-if="errors.has('name')">
            {{ $t('message.required_field') }}
          </div>
        </div>
        <div class="form-group">
          <label for="email">
            {{ $t('message.big_cleaning.contact_email') }}
            <span class="text-danger">*</span>
          </label>
          <input type="email"
                 class="form-control input-jumbo"
                 name="email"
                 id="email"
                 v-model="contactData.email"
                 ref="email"
                 v-validate="'required'">
          <div class="mt-2 text-remark -status-alert" v-if="errors.has('email')">
            {{ $t('message.required_field') }}
          </div>
        </div>
        <div class="form-group">
          <label for="tel">
            {{ $t('message.big_cleaning.contact_tel') }}
            <span class="text-danger">*</span>
          </label>
          <input type="tel"
                 class="form-control input-jumbo"
                 name="tel"
                 id="tel"
                 v-model="contactData.tel"
                 ref="tel"
                 v-validate="{ required: true, min: 10, max: 15, regex: /^\+?[0-9-]+$/ }">
          <div class="mt-2 text-remark -status-alert" v-if="errors.has('tel')">
            {{ $t('message.required_field') }}
          </div>
        </div>
        <button class="btn btn-info" @click="checkContactData">
          {{ $t('message.button.save') }}
        </button>
      </section>

      <!-- Service purpose -->
      <div class="form-group mt-4" v-if="serviceId === 13">
        <label>
          {{ $t('message.service_request.big_cleaning_purpose') }}
          <span class="text-danger">*</span>
        </label>
        <div class="select-jumbo">
          <select v-model="contactData.serviceRequestPurposeId">
            <template v-for="data in globalState.configData.big_cleaning_types">
              <option :value="data.id">{{ data | multiLangName }}</option>
            </template>
          </select>
        </div>
      </div>

      <!-- Service date -->
      <div class="row mt-4" v-if="serviceId === 13">
        <div class="col-12 p-0">
          <label>
            {{ $t('message.service_request.big_cleaning_service_date') }}
            <span class="text-danger">*</span>
          </label>
        </div>
        <div class="col-6 p-0">
          <div class="form-group mr-2">
            <input type="text"
                   name="serviceDate"
                   :placeholder="$i18n.t('message.booking.booking_step.date')"
                   class="form-control -date-picker input-jumbo"
                   v-pikadayBooking="calendarData"
                   ref="cleaningDate"
                   readonly
                   v-validate="'required'"/>
            <span class="far fa-calendar-alt input-text-icon"></span>
            <div class="mt-2 text-remark -status-alert" v-if="errors.has('serviceDate')">
              {{ $t('message.required_field') }}
            </div>
          </div>
        </div>
        <div class="col-6 p-0">
          <div class="form-group ml-2">
            <div class="select-jumbo">
              <select style="background: white;" v-model="contactData.serviceTime">
                <option :value="time" v-for="time in globalState.arrTimes">{{ time }}</option>
              </select>
              <span class="far fa-clock input-text-icon"></span>
            </div>
          </div>
        </div>
      </div>

      <!-- Building type -->
      <div class="form-group mt-4">
        <label>
          {{ textData.labelType }}
          <span class="text-danger">*</span>
        </label>
        <div class="select-jumbo">
          <select v-model="contactData.buildingTypeId"
                  v-validate="'required'"
                  :class="{'form-alert': errors.has('buildingType')}"
                  name="buildingType">
            <option :value="null">{{ $t('message.service_request.big_cleaning_building_type_require') }}</option>
            <template v-for="data in dataTypes">
              <option :value="data.id">{{ data | multiLangName }}</option>
            </template>
          </select>
          <div class="mt-2 text-remark -status-alert" v-if="errors.has('buildingType')">
            {{ $t('message.required_field') }}
          </div>
        </div>
      </div>

      <!-- Building size -->
      <div class="form-group">
        <label for="buildingSize">
          {{ textData.labelSize }}
          <span class="text-danger">*</span>
        </label>
        <div class="text-remark mb-2" v-if="serviceId === 13">
          {{ $t('message.service_request.big_cleaning_building_size_remark') }}
        </div>
        <input type="text"
               class="form-control input-jumbo"
               name="buildingSize"
               id="buildingSize"
               :placeholder="textData.hintSize"
               v-model="contactData.buildingSize"
               :class="{'form-alert': errors.has('buildingSize')}"
               v-validate="'required'">
        <div class="mt-2 text-remark -status-alert" v-if="errors.has('buildingSize')">
          {{ $t('message.required_field') }}
        </div>
      </div>

      <!-- Building address -->
      <div class="form-group">
        <label for="buildingAddress">
          {{ $t('message.service_request.big_cleaning_building_address') }}
          <span class="text-danger">*</span>
        </label>
        <textarea rows="2"
                  ref="buildingAddress"
                  name="buildingAddress"
                  id="buildingAddress"
                  :class="{'form-alert': errors.has('buildingAddress')}"
                  class="form-control textarea-jumbo"
                  :placeholder="$t('message.service_request.big_cleaning_building_address_placeholder')"
                  v-model="contactData.buildingAddress"
                  v-validate="'required'"></textarea>
        <div class="mt-2 text-remark -status-alert" v-if="errors.has('buildingAddress')">
          {{ $t('message.required_field') }}
        </div>
      </div>

      <div class="form-group">
        <label for="province_address"> {{ $t('message.service_request.big_cleaning_building_province') }} <span class="text-danger">*</span></label>
        <v-select v-model="contactData.province_id"
                  :class="{'form-alert': errors.has('province_address')}"
                  v-validate="'required'"
                  :options="provinces"
                  :placeholder="$t('message.service_request.big_cleaning_building_require_province')"
                  label="name_th"
                  ref="province_address"
                  id="province_address"
                  name="province_address"
                  :reduce="province => province.id"
                  @input="getDistricts"
                  :selectable="option => !(option.id == 0)">

          <template v-slot:option="option">
            {{ option.name_th }}
          </template>
        </v-select>
        <div class="mt-2 text-remark -status-alert" v-if="errors.has('province_address')">
          {{ $t('message.required_field') }}
        </div>
      </div>


      <div class="form-group">
        <label for="district_address"> {{ $t('message.service_request.big_cleaning_building_district') }} <span class="text-danger">*</span></label>
        <v-select v-model="contactData.district_id"
                  :class="{'form-alert': errors.has('district_address')}"
                  v-validate="'required'"
                  :options="districts"
                  :placeholder="$t('message.service_request.big_cleaning_building_require_district')"
                  label="name_th"
                  ref="district_address"
                  id="district_address"
                  name="district_address"
                  :reduce="district => district.id"
                  @input="getSubDistricts"
                  :selectable="option => !(option.id == 0)">


          <template v-slot:option="option">
            {{ option.name_th }}
          </template>
        </v-select>
        <div class="mt-2 text-remark -status-alert" v-if="errors.has('district_address')">
          {{ $t('message.required_field') }}
        </div>
      </div>


      <div class="form-group">
        <label for="sub_district_address"> {{ $t('message.service_request.big_cleaning_building_sub_district') }}</label>
        <v-select v-model="contactData.sub_district_id"
                  :options="subDistricts"
                  :placeholder="$t('message.service_request.big_cleaning_building_require_sub_district')"
                  label="name_th"
                  ref="sub_district_address"
                  id="sub_district_address"
                  name="sub_district_address"
                  :reduce="sub_district => sub_district.id"
                  :selectable="option => !(option.id == 0)">

          <template v-slot:option="option">
            {{ option.name_th }}
          </template>
        </v-select>
      </div>


      <!-- Attach photos -->
      <div>
        <label>{{ $t('message.service_request.big_cleaning_attach_photos') }}</label>
        <div class="text-remark mb-2">{{ $t('message.service_request.big_cleaning_attach_photos_remark') }}
        </div>
        <vue-dropzone ref="vueDropzone"
                      id="dropzone"
                      class="dropzone-dashed"
                      :options="dropzoneOptions"/>
      </div>

      <!-- Remark -->
      <div class="form-group mt-3">
        <label for="remark">{{ $t('message.service_request.big_cleaning_remark') }}</label>
        <textarea rows="2"
                  ref="remark"
                  id="remark"
                  :placeholder="textData.hintRemark"
                  class="form-control textarea-jumbo"
                  v-model="contactData.remark"></textarea>
      </div>

      <div class="mt-3">
        <hr>
      </div>

      <div class="my-4">
        <label class="text-orange">{{ $t('message.service_request.remark') }}</label>
        <div class="text-order-notification">
          <span class="bullet-notification -status-pending">
            <i class="fas fa-circle"></i>
          </span>
          {{ $t('message.service_request.service_request_remark01') }}
        </div>
        <div class="text-order-notification mt-3">
          <span class="bullet-notification -status-pending">
            <i class="fas fa-circle"></i>
          </span>
          {{ $t('message.service_request.service_request_remark02') }}
        </div>
      </div>

      <button class="button button-block button-large -cyan"
              @click="validation"
              :disabled="isSubmitting">
        {{ isSubmitting ? $t('message.button.loading') : $t('message.button.submit_request') }}
      </button>

      <hr>
      <div class="mt-4 mb-3 text-center">
        <h3>{{ $t('message.big_cleaning.or_contact_customer_service') }}</h3>
        <div class="business-contact">
          <div class="mb-3">
            <i class="fas fa-phone-square text-primary"></i>
            <a href="tel:021131138">02-113-1138</a>
          </div>
          <div class="mb-3">
            <!-- <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
              LINE ID: @BeNeat
            </a> -->
            <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
              LINE ID: @BeNeat
            </a>
          </div>
          <div class="mt-3">
            <!-- <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
              <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
            </a> -->
            <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
              <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
            </a>
          </div>
        </div>
      </div>
      <!-- end contact -->
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
import moment from 'moment-timezone'
import vSelect from 'vue-select'

export default {
  props: {
    serviceId: Number
  },
  components: {
    vueDropzone: vue2Dropzone,
    'v-select': vSelect
  },
  data () {
    return {
      provinces: [],
      districts: [],
      subDistricts: [],
      textData: {
        quotationTitle: null,
        labelType: null,
        labelSize: null,
        hintSize: null
      },
      dataTypes: null,
      contactData: {
        name: null,
        email: null,
        tel: null,
        serviceRequestPurposeId: null,
        buildingTypeId: null,
        buildingSize: null,
        buildingAddress: null,
        province_id: null,
        district_id: null,
        sub_district_id: null,
        serviceTime: '10:00',
        remark: ''
      },
      calendarData: {
        date: null,
        isToday: false
      },
      dropzoneOptions: {
        acceptedFiles: 'image/*',
        url: 'https://beneat.co',
        thumbnailWidth: 160,
        thumbnailHeight: 160,
        maxFilesize: 2,
        dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.upload_photos')}`,
        headers: { 'Content-Type': 'multipart/form-data' },
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 15
      },
      isEditing: false,
      isSubmitting: false
    }
  },
  computed: {
    ...mapGetters({
      globalState: 'globalVal/getState',
      isSendingEmail: 'business/getIsSendingEmail',
      isSending: 'business/isSending',
      user: 'auth/getUser'
    })
  },
  methods: {
    async getProvinces () {
      let { data } = await axios.get('/address-provinces')
      if (!data.error) {
        this.provinces = data.address_provinces
      } else {
        this.$swal({ text: 'No Data', type: 'error' })
      }
    },
    async getDistricts () {
      this.districts = []
      this.subDistricts = []
      this.contactData.district_id = null
      this.contactData.sub_district_id = null
      if (this.contactData.province_id) {
        let { data } = await axios.get('/districts', {
          params: {
            province_id: this.contactData.province_id
          }
        })
        if (!data.error) {
          this.districts = data.districts
          console.log('districttt', data.districts)
        } else {
          this.$swal({ text: 'No Data', type: 'error' })
        }
      }
    },
    async getSubDistricts () {
      this.subDistricts = []
      this.contactData.sub_district_id = null
      if (this.contactData.district_id) {
        let { data } = await axios.get('/sub-districts', {
          params: {
            district_id: this.contactData.district_id
          }
        })
        if (!data.error) {
          this.subDistricts = data.sub_districts
        } else {
          this.$swal({ text: 'No Data', type: 'error' })
        }
      }
    },
    setTextLabel (serviceId) {
      switch (serviceId) {
        case 13:
        case 24:
          this.textData.quotationTitle = (serviceId === 13) ? this.$i18n.t('message.service_request.big_cleaning_quotation_request') : this.$i18n.t('message.service_request.disinfectant_cleaning_quotation_request')
          this.textData.labelType = this.$i18n.t('message.service_request.big_cleaning_building_type')
          this.textData.labelSize = this.$i18n.t('message.service_request.big_cleaning_building_size')
          this.textData.hintSize = this.$i18n.t('message.service_request.big_cleaning_building_size_placeholder')
          this.textData.hintRemark = this.$i18n.t('message.service_request.big_cleaning_remark_placeholder')
          break
        case 16:
          this.textData.quotationTitle = this.$i18n.t('message.service_request.ac_cleaning_quotation_request')
          this.textData.labelType = this.$i18n.t('message.service_request.ac_cleaning_ac_type')
          this.textData.labelSize = this.$i18n.t('message.service_request.ac_cleaning_ac_size')
          this.textData.hintSize = this.$i18n.t('message.service_request.ac_cleaning_ac_size_placeholder')
          this.textData.hintRemark = this.$i18n.t('message.service_request.ac_cleaning_remark_placeholder')
          break
      }
    },
    checkContactData () {
      if (!this.errors.has('name') && !this.errors.has('email') && !this.errors.has('tel')) {
        this.isEditing = false
      }
    },
    validation () {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$swal({
            title: this.$i18n.t('message.service_request.big_cleaning_service_confirm_title'),
            text: this.$i18n.t('message.service_request.big_cleaning_service_confirm_description'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#9E9E9E',
            reverseButtons: true,
            confirmButtonText: this.$i18n.t('message.confirm.yes'),
            cancelButtonText: this.$i18n.t('message.confirm.cancel')
          }).then(() => {
            this.submitData()
          })
        }
      })
    },
    submitData () {
      this.isSubmitting = true
      // Prepare form data
      let serviceDate = moment(this.calendarData.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      serviceDate += ' ' + this.contactData.serviceTime
      // console.log(serviceDate)
      let formData = new FormData()
      // Check user
      /* let userId = (this.user) ? this.user.id : null
      if (!userId) {
        userId = 8216
      }

      formData.append('user_id', userId) */
      formData.append('service_id', this.serviceId)
      formData.append('service_date', serviceDate)
      formData.append('name', this.contactData.name)
      formData.append('email', this.contactData.email)
      formData.append('tel', this.contactData.tel)
      if (this.contactData.serviceRequestPurposeId) {
        formData.append('service_request_purpose_id', this.contactData.serviceRequestPurposeId)
      }
      formData.append('building_type_id', this.contactData.buildingTypeId)
      formData.append('building_size', this.contactData.buildingSize)
      formData.append('building_address', this.contactData.buildingAddress)
      formData.append('address_province_id', this.contactData.province_id)
      formData.append('district_id', this.contactData.district_id)
      if (this.contactData.sub_district_id) {
        formData.append('sub_district_id', this.contactData.sub_district_id)
      }

      formData.append('remark', this.contactData.remark)

      // Prepare file uploads
      const queueFiles = this.$refs.vueDropzone.getQueuedFiles()
      for (let key in queueFiles) {
        formData.append('upload_image[]', queueFiles[key])
      }
      let url = 'service-requests/form-send-telegram'
      axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          this.isSubmitting = false
          const serviceRequest = response.data.service_request
          this.displayCompleteDialog(serviceRequest.id)
        })
        .catch((error) => {
          this.isSubmitting = false
          console.log(error)
        })
    },
    displayCompleteDialog (serviceRequestId) {
      if (this.user) {
        this.$swal({
          title: this.$i18n.t('message.success'),
          text: this.$i18n.t('message.service_request.success_message'),
          type: 'success',
          confirmButtonText: this.$i18n.t('message.service_request.see_request_detail')
        }).then((result) => {
          if (result) {
            this.$router.push('/service-requests/' + serviceRequestId)
          }
        })
      } else {
        this.$swal({
          title: this.$i18n.t('message.success'),
          text: this.$i18n.t('message.service_request.success_message'),
          type: 'success'
        })
      }
    }
  },
  mounted () {
    this.setTextLabel(this.serviceId)
    switch (this.serviceId) {
      case 13:
      case 24:
        this.dataTypes = this.globalState.configData.building_types
        this.contactData.serviceRequestPurposeId = this.globalState.configData.big_cleaning_types[0].id
        break
    }

    if (this.user) {
      this.contactData.name = this.user.name
      this.contactData.email = this.user.email
      this.contactData.tel = this.user.tel
    } else {
      this.isEditing = true
    }

    this.calendarData.date = moment().format('DD/MM/YYYY')
  },
  created () {
    this.getProvinces()
  }
}
</script>

<style scoped>
@import "~vue-select/dist/vue-select.css";

.input-text-icon {
  float: right;
  margin-right: 1rem;
  margin-top: -2.15rem;
  position: relative;
  font-size: 120%;
  z-index: 2;
  color: #9E9E9E;
}
</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/RequestForm.vue